import React, { Component } from 'react'
import { Card, CardLink, CardBody, Form, Input, FormFeedback, FormGroup, Button, Label } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import validaciones from '../../Auxiliares/validaciones'

export default class modModulo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            nombre: this.props.nombre,
            integrantes: this.props.integrantes,
            usuarios: this.props.usuarios,
            errors: {}
        }
        this.guardar = this.guardar.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        console.log(this.props.integrantes, this.props.usuarios, this.diferenciaUsuarios)
    }
    

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, ()=> {
            let value;
            switch([field].toString()){
                case 'nombre':
                    if (validaciones.validar_titulo(this.state.doc)) {
                        value = validaciones.validar_titulo(this.state.doc)
                        this.setState(prevState => ({ errors: { ...prevState.errors, doc: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).doc) });
                    }
                break;

                default:
                    break;
            }
        })
    }

    handleChange = (e) => {
        if (e.target.checked) {
            this.state.integrantes.push(this.state.usuarios[e.target.id]);
        } else {
            let i = this.state.integrantes.indexOf(this.state.usuarios[e.target.id]);
            this.state.integrantes.splice(i, 1);
        }
        this.state.integrantes.sort();
    }

    guardar() {
        const { id, nombre, integrantes } = this.state

        if (validaciones.sinErrores(this.state.errors)) {
            Fetch('/api/updateGrupo', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id, nombre, integrantes })
            }).then(Response => {
                this.props.actualizar();
                this.props.cerrar(); 
            }).catch(err => {
                switch (err.status) {
                    case 600:
                        toast.error('Error inesperado'+JSON.stringify(err))
                        break;

                    case 601:
                        toast.error('Este grupo ya existe')
                        break;
                        
                    case 602:
                        toast.error('Este usuario no existe')
                    break;
                    
                    case 604:
                        toast.error('Este grupo no pudo ser registrado')
                        break;
                    
                    default:
                        toast.error(err.status)
                    break;
                }
            })
        }
    }

    render() {

        return (
            <Card className="border-0">
                <CardBody>
                    <Form method="post" encType="multipart/form-data">
                        <FormGroup>
                            <Input type="text" name="nombre" id="nombre" placeholder="Nombre" onChange={this.setValue.bind(this, 'nombre')} className="mb-3 py-4 d-flex w-100 font-weight-bold" defaultValue={this.state.nombre} invalid={this.state.errors.nombre} />
                            <FormFeedback>{this.state.errors.nombre}</FormFeedback>
                        </FormGroup>

                        <div className="overflow-auto" style={{height: '400px'}}>

                        {this.state.integrantes.map((elem) => (
                            <div name="item">
                                <Card className="p-3 px-3 my-1 text-left">
                                    <div check className="form-check mb-2">
                                        <Label check className="form-check-label">
                                            <Input type="checkbox" className="form-check-input filled-in" defaultChecked onChange={this.handleChange} id={elem._id} invalid={this.state.errors.integrantes} />{' '}{elem.nombre}
                                        </Label>
                                    </div>
                                </Card>
                            </div>
                        ))}

                        {this.state.usuarios.map((elem, index) => (
                            <div name="item">
                                <Card className="p-3 px-3 my-1 text-left">
                                    <div check className="form-check mb-2">
                                        <Label check className="form-check-label">
                                            <Input type="checkbox" className="form-check-input filled-in" onChange={this.handleChange} id={index} invalid={this.state.errors.integrantes} />{' '}{elem.nombre}
                                        </Label>
                                    </div>
                                </Card>
                            </div>
                        ))}

                        </div>

                        <div className="text-center">
                        <CardLink>
                            <Button color="info" onClick={this.guardar}>Guardar</Button>
                            <Button color="white" onClick={this.props.cerrar} >Cancelar</Button>
                        </CardLink>
                        </div>
                    </Form>
                </CardBody>
            </Card >
        )
    }
}
